import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import asianPilatesLpWebp from '@/assets/landing/asian-pilates-lp.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: '28-Day Asian Pilates Challenge based on your age',
			size: 'small',
			customStyles: {
				marginLeft: '2rem',
				marginRight: '2rem',
			},
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: asianPilatesLpWebp,
			customStyles: {
				maxWidth: 'none',
				maxHeight: '50vh',
				marginTop: 'var(--size-18)',
				marginBottom: 'var(--size-18)',
				marginLeft: '-20px',
				marginRight: '-20px',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
